import { teamsEpics } from './teams';

export const entitiesEpics = [...teamsEpics];
